// import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./Login";
// import Register from "./Register";
// import Reset from "./Reset";
import Dashboard from "./Dashboard";

function App() {
  return (
    <div className="flex justify-center items-top w-screen h-screen">
      <Router>
        <Routes>
          <Route exact path="/" element={<Login />} />
          {/* <Route exact path="/register" element={<Register />} />
          <Route exact path="/reset" element={<Reset />} /> */}
          <Route exact path="/kalkulator" element={<Dashboard />} />
          <Route path="/kalkulator" element={<Dashboard />} />
          <Route path="/kalkulator/:flottaId" element={<Dashboard />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
